// extracted by mini-css-extract-plugin
module.exports = {"desktopModalPaper":"AffliateDiscountModal_desktopModalPaper__RuK2_"};